<div class="date-container">
  <eg-input
    class="ngx-daterangepicker-action"
    [value]="formattedValue"
    [label]="labelWithSuffix"
    [name]="name"
    [placeholder]="placeholder"
    [readonly]="true"
    [disabled]="disabled"
    (click)="openDatePicker($event)"
    (blurred)="markInputAsTouched()"
  >
    <img egFieldSuffixDirective src="/assets/icons/field_date.svg" class="date-icon ngx-daterangepicker-action" />
  </eg-input>

  <p-datepicker
    #dateRange
    class="p-calendar date-range"
    [appendTo]="appendTo"
    [(ngModel)]="dates"
    inputId="dateRangeInput"
    [minDate]="minDateFormatted"
    [maxDate]="maxDateFormatted"
    [readonlyInput]="true"
    [placeholder]="placeholder"
    [showClear]="showClearButton"
    dateFormat="dd/mm/yy"
    selectionMode="range"
    [numberOfMonths]="2"
    (onSelect)="onInputChanged()"
    (onClose)="onDatepickerClosed()"
  >
  </p-datepicker>

  @if (control?.touched && control?.errors && errorMessage) {
    <eg-form-error [errorMessage]="errorMessage" class="input-error"></eg-form-error>
  }
</div>
